import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import styled from 'styled-components';

import GetUpdatesCheckbox from '../Widget/GetUpdatesCheckbox';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupHalf,
    MultipleGroupFull
} from '../../containers/DefaultStyles/FormDetails';

import { LoadingSpinner } from '../../components/LoadingSpinner';
import Button from '../Button';
import InputGroup from '../InputGroup';
import ReactGoogleAutocomplete from '../InputFields/GoogleMapsAddressField';
import TwoGroup from '../TwoGroup';

import { getCachedFirstName, getCachedLastName } from '../../utils/formCaching/helpers';
import { isPortrait } from '../../utils/size';
import validate from './validations';

const CheckboxWrapper = styled.div`
    ${props =>
        !isPortrait() &&
        `
        max-width: 44%;
        left: -195px;
        top: ${props.isEu ? 260 : 265}px;
        position: absolute;`};
`;

class ElectionReminderForm extends React.Component {
    constructor() {
        super();
        this.state = {
            valid: false
        };
    }

    setValidState(bool) {
        this.setState({ valid: bool });
    }

    render() {
        return (
            <Container
                noOverflow
                autocomplete="on"
                onSubmit={this.props.handleSubmit}
            >
                <MultipleGroupHalf>
                    <Field
                        name="firstName"
                        component={InputGroup}
                        type="text"
                        label="First name"
                        placeholder="First Name"
                        autocomplete="off"
                    />
                    <Field
                        name="lastName"
                        component={InputGroup}
                        type="text"
                        label="Last name"
                        placeholder="Last Name"
                        autocomplete="off"
                    />
                </MultipleGroupHalf>
                <MultipleGroupFull>
                    <ReactGoogleAutocomplete
                        formName={['electionReminderForm', 'google_autocomplete']}
                        fields={['address_components', 'formatted_address']}
                        types={['address']}
                        componentRestrictions={{ country: 'US' }}
                        setValidState={this.setValidState.bind(this)}
                        typeToReturn={'object'}
                    />
                </MultipleGroupFull>
                <MultipleGroupFull style={{ marginBottom: '12px' }}>
                    <Field
                        name="email"
                        component={InputGroup}
                        type="email"
                        label="Email"
                        placeholder="Email"
                        autocomplete="off"
                    />
                </MultipleGroupFull>
                <CheckboxWrapper isEU={this.props.endUserLocation.isEU}>
                    <GetUpdatesCheckbox
                        style={{ paddingTop: 0 }}
                        isEU={this.props.endUserLocation.isEU}
                    />
                </CheckboxWrapper>
                <ButtonGroupWrapper
                    isFormSubmitting={this.props.isFormSubmitting}
                    rightPosition={23}
                >
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            type="submit"
                            label="Continue"
                            className="submitButton"
                            disabled={this.props.invalid || !this.state.valid}
                            isSubmitting={this.props.isFormSubmitting}
                        />
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

ElectionReminderForm.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    isFormSubmitting: PropTypes.bool,
    endUserLocation: PropTypes.object.isRequired
};

export default compose(
    connect(state => ({
        initialValues: {
            getUpdates: !(state.widget.endUserLocation || {}).isEU,
            firstName: getCachedFirstName(state),
            lastName: getCachedLastName(state),
            address: state.cachedFormData.address || ''
        },
        endUserLocation: state.widget.endUserLocation || {}
    })),
    reduxForm({
        form: 'electionReminderForm',
        destroyOnUnmount: false,
        validate
    })
)(ElectionReminderForm);
